import React, { Component } from "react";
import styled from "styled-components";
import { Block, Divider, InlineBlock, Popover, Tabs } from "reakit";
import { Box, Card, Flex, Image, Text } from "rebass";
import { TabHeader } from "../Base";
import { withFirebase } from "../Firebase";
import { MapMarkerAlt } from "styled-icons/fa-solid";
import check from "../../resources/img/icons/Checkbox@1x-black.png";
import IosArrowDown from "react-ionicons/lib/IosArrowDown";
import IosArrowUp from "react-ionicons/lib/IosArrowUp";
// import { MoveFocusInside } from 'react-focus-lock';

const Wrapper = styled(InlineBlock)`
  width: 40vw;
  //	z-index: 9210;
`;

const PanelWrapper = styled(Box)`
  //overflow: hidden;
  min-width: 400px;
  //z-index: 9210;

  width: 400px;
  max-height: calc(50vh - 50px);
  overflow-y: auto !important; /* [1] */
  -webkit-overflow-scrolling: touch !important; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar !important; /* [5] */
`;

const MapMarker = styled(MapMarkerAlt)`
  width: 20px;
  height: 20px;
  color: white;
  margin-right: 10px;
`;

const textProps = {
  ml: 3,
};

class WaveDropdown extends Component {
  state = {
    current: null,
    locations: [],
    history: [],
    locationMap: {},
  };

  componentDidMount() {
    const { school } = this.props;
    console.log(school);
    this.setState({
      locations: school.locations.list,
      locationMap: school.locations.map,
    });
    this.returnStudentListner();
  }

  returnStudentListner = () => {
    const { profile } = this.props;
    this.setState({ current: profile.current_location });
  };

  handleSelect = (location, toggle) => {
    //console.log('selected', location);
    const { isFaculty, student, profile } = this.props;
    if (isFaculty) {
      // todo
      let studentRef = this.props.firebase.student(student.id);
      let waveRef = studentRef.collection("wave_history");
      let newWave = waveRef.doc();
      newWave.set({
        creator_uid: profile.id,
        location_is_geowave: false,
        location_uid: location.id,
        post_time: Math.floor(Date.now() / 1000),
      });
      studentRef.update({
        current_location: location.id,
      });
    } else {
      let studentRef = this.props.firebase.student(student.id);
      let waveRef = studentRef.collection("wave_history");
      let newWave = waveRef.doc();
      newWave.set({
        creator_uid: profile.id,
        location_is_geowave: false,
        location_uid: location.id,
        post_time: Math.floor(Date.now() / 1000),
      });
      studentRef.update({
        current_location: location.id,
      });

      this.setState({ current: location.id });
      toggle();
    }
  };

  componentWillUnmount() {}

  render() {
    const { locations, current, locationMap } = this.state;
    const { student, school, isFaculty } = this.props;

    let location = "";
    if (!isFaculty && current !== null) {
      const locationData = locationMap[current];
      let campus = "";
      if (locationData) {
        if (locationData.is_oncampus === true) {
          campus = "ON - ";
        } else {
          campus = "OFF - ";
        }
        location = campus + locationData.name;
      }
    }

    if (student && student.on_leave && school.leaveTypes[student.leave_type]) {
      location = school.leaveTypes[student.leave_type].name;
    }
    return (
      <Popover.Container>
        {(popover) => (
          <Wrapper>
            <Card p={3} width={1} boxShadow={"main"} bg={"gray"}>
              <Flex onClick={student.on_leave ? null : popover.toggle}>
                <Box>
                  <Text fontWeight={600}>
                    <MapMarker />
                    {location}
                  </Text>
                </Box>
                <Box ml={"auto"} />
                {student && !student.on_leave && (
                  <Flex width={1 / 5} {...popover}>
                    <Box ml={"auto"} />
                    {popover.visible ? (
                      <IosArrowUp marginRight={"auto"} color={"white"} />
                    ) : (
                      <IosArrowDown marginRight={"auto"} color={"white"} />
                    )}
                  </Flex>
                )}
              </Flex>
            </Card>
            <Popover
              fade
              slide
              expand
              hideOnClickOutside
              {...popover}
              padding={0}
              margin={0}
              borderRadius={0}
            >
              <Tabs.Container>
                {(tabs) => (
                  <Block maxHeight={"50vh"} relative>
                    <Tabs backgroundColor={"white"}>
                      <Tabs.Tab tab="on" {...tabs}>
                        <TabHeader title={"ON"} />
                      </Tabs.Tab>
                      <Tabs.Tab tab="off" {...tabs}>
                        <TabHeader title={"OFF"} />
                      </Tabs.Tab>
                    </Tabs>

                    <Tabs.Panel tab="on" {...tabs}>
                      <PanelWrapper>
                        <Divider />
                        {locations
                          .filter((item) => item.is_oncampus)
                          .map((location) =>
                            location.activated ? (
                              <Box
                                key={location.id}
                                onClick={() =>
                                  this.handleSelect(location, popover.toggle)
                                }
                              >
                                <Flex>
                                  <Box>
                                    <Text {...textProps}>{location.name}</Text>
                                  </Box>
                                  <Box ml={"auto"} />
                                  <Box pr={2}>
                                    {current === location.id && (
                                      <Image src={check} />
                                    )}
                                  </Box>
                                </Flex>
                                <Box width={1}>
                                  <Divider />
                                </Box>
                              </Box>
                            ) : (
                              ""
                            )
                          )}
                      </PanelWrapper>
                    </Tabs.Panel>

                    <Tabs.Panel tab="off" {...tabs}>
                      <PanelWrapper>
                        <Divider />
                        {locations
                          .filter((item) => !item.is_oncampus)
                          .map((location) =>
                            location.activated ? (
                              <Box
                                key={location.id}
                                onClick={() =>
                                  this.handleSelect(location, popover.toggle)
                                }
                              >
                                <Flex>
                                  <Box>
                                    <Text {...textProps}>{location.name}</Text>
                                  </Box>
                                  <Box ml={"auto"} />
                                  <Box pr={2}>
                                    {current === location.id && (
                                      <Image src={check} />
                                    )}
                                  </Box>
                                </Flex>
                                <Box width={1}>
                                  <Divider />
                                </Box>
                              </Box>
                            ) : (
                              ""
                            )
                          )}
                      </PanelWrapper>
                    </Tabs.Panel>
                  </Block>
                )}
              </Tabs.Container>
            </Popover>
          </Wrapper>
        )}
      </Popover.Container>
    );
  }
}

export default withFirebase(WaveDropdown);
